declare const __liveChatConfig: {
    apiBase: string;
    appId: string;
    shutdownCookieName: string;
    jwt?: string;
    tokenEndpoint?: string;
};

import LiveChatLoader from './LiveChatLoader';

new LiveChatLoader(__liveChatConfig).start();
